import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/cXmUtPRRnPDEgeYjNVhKvK/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/gXxA8zJNU2f1f5B9KWEmtq/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/woQq69mkjUiAX4pjM1dr4r/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/ia791jJkXmuUyU8uL2Thu4/pasted-image.jpg'];
export function PortfolioCarousel() {
  // We duplicate the array to create a seamless infinite loop
  const duplicatedImages = [...images, ...images];
  return <section className="py-10 flex flex-col items-center overflow-hidden w-full" data-id="element-142">
      <h2 className="font-serif text-3xl md:text-5xl text-brand-navy mb-10 px-6 text-center" data-id="element-143">
        Mi Portfolio 💘
      </h2>
      <div className="w-full flex" data-id="element-144">
        <motion.div className="flex gap-4 px-2" animate={{
        x: [0, -1344] // 4 images * (320px width + 16px gap) = 1344px
      }} transition={{
        duration: 25,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-145">
          {duplicatedImages.map((src, i) => <div key={i} className="w-[320px] md:w-[400px] bg-white rounded-3xl overflow-hidden shadow-lg border border-white/50 shrink-0" data-id="element-146">
              <img src={src} alt={`Portfolio item ${i + 1}`} className="w-full h-auto block" data-id="element-147" />
            </div>)}
        </motion.div>
      </div>

      <p className="text-brand-navy/40 text-[10px] mt-6 uppercase tracking-widest font-bold" data-id="element-148">
        Marcas y trabajos realizados ✨
      </p>
    </section>;
}